import styled from 'styled-components';

export const HEADER_HEIGHT = '65px';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export default HeaderContainer;
